/**
 * Admin Panel Redirect
 *
 * The standalone /admin page has been consolidated into /settings/admin.
 * This component redirects there for backward compatibility.
 */

import { Navigate } from 'react-router-dom';

export default function AdminPanel() {
  return <Navigate to="/settings/admin" replace />;
}
